import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table view for currency exchange rates.
 * @extends JetView
 */
export default class tableTrmView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide', // Type of the view
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Column definitions
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template for rendering the column
                                        return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
                                    },
                                },
                                {
                                    id: 'id', // Column ID
                                    header: _('Id'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'value', // Column ID
                                    header: _('País'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'baseCurrency', // Column ID
                                    header: _('Moneda'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmUsd', // Column ID
                                    header: _('USD'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmNio', // Column ID
                                    header: _('NIO'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmMxn', // Column ID
                                    header: _('MXN'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmPen', // Column ID
                                    header: _('PEN'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmBrl', // Column ID
                                    header: _('BRL'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmClp', // Column ID
                                    header: _('CLP'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmCrc', // Column ID
                                    header: _('CRC'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmGtq', // Column ID
                                    header: _('GTQ'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmGyd', // Column ID
                                    header: _('GYD'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmJmd', // Column ID
                                    header: _('JMD'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'trmVes', // Column ID
                                    header: _('VES'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            on: {
                                // Event handlers for the datatable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            onClick: {
                                // Click event handlers
                                edit: function (euv, id) {
                                    // Edit icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('openEdit', [item]); // Trigger edit event
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'Setting/GetCurrenciesTrm'; // API URL for fetching currency data
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'report:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'DateM') {
                            // Handle month range
                            var date = object[i][1].split(' - ');
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            if (object[i][0] != 'Date') {
                                // Handle other filters
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                            } else {
                                if (object[i][0] == 'Date') {
                                    // Handle single date
                                    var date = object[i][1].replace(' 00:00:00', '');
                                    string1 = string1 + '&dateFrom=' + date;
                                    string1 = string1 + '&dateTo=' + date;
                                }
                                if (object[i][0] == 'DateM2') {
                                    // Handle second month range
                                    var date = object[i][1].replace(' 00:00:00', '');
                                    string1 = string1 + '&dateFrom2=' + date;
                                    string1 = string1 + '&dateTo2=' + date;
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            filter = string1; // Update filter string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for opening the edit window
        this.on(this.app, 'openEdit', (item) => {
            webix
                .ui({
                    view: 'window', // Create a window for editing
                    id: 'editMenu', // Unique identifier for the window
                    fullscreen: screen.width < 500 ? true : false, // Fullscreen on small screens
                    width: 500, // Window width
                    head: {
                        // Window header
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Editar'), // Localized label
                                align: 'center',
                            },
                            {
                                view: 'icon',
                                icon: 'wxi-close', // Close icon
                                click: function () {
                                    // Close button click
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        // Window body
                        view: 'form', // Form view
                        id: 'editform', // Unique identifier for the form
                        elements: [
                            // Form elements
                            {
                                cols: [
                                    // Two-column layout
                                    {
                                        margin: 10, // Margin for the column
                                        rows: [
                                            // Row elements
                                            {
                                                view: 'text', // Text input for ID
                                                labelPosition: 'top',
                                                label: _('Id'), // Localized label
                                                name: 'id', // Input name
                                                readonly: true, // Read-only field
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'text', // Text input for base currency
                                                labelPosition: 'top',
                                                label: _('Moneda'), // Localized label
                                                name: 'baseCurrency', // Input name
                                                readonly: true, // Read-only field
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'text', // Text input for NIO
                                                labelPosition: 'top',
                                                label: _('NIO'), // Localized label
                                                name: 'trmNio', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for PEN
                                                labelPosition: 'top',
                                                label: _('PEN'), // Localized label
                                                name: 'trmPen', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for CLP
                                                labelPosition: 'top',
                                                label: _('CLP'), // Localized label
                                                name: 'trmClp', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for GTQ
                                                labelPosition: 'top',
                                                label: _('GTQ'), // Localized label
                                                name: 'trmGtq', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for JMD
                                                labelPosition: 'top',
                                                label: _('JMD'), // Localized label
                                                name: 'trmJmd', // Input name
                                                type: 'number', // Number input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the column
                                        rows: [
                                            // Row elements
                                            {
                                                view: 'text', // Text input for country
                                                labelPosition: 'top',
                                                label: _('País'), // Localized label
                                                name: 'value', // Input name
                                                readonly: true, // Read-only field
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'text', // Text input for USD
                                                labelPosition: 'top',
                                                label: _('USD'), // Localized label
                                                name: 'trmUsd', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for MXN
                                                labelPosition: 'top',
                                                label: _('MXN'), // Localized label
                                                name: 'trmMxn', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for BRL
                                                labelPosition: 'top',
                                                label: _('BRL'), // Localized label
                                                name: 'trmBrl', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for CRC
                                                labelPosition: 'top',
                                                label: _('CRC'), // Localized label
                                                name: 'trmCrc', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for GYD
                                                labelPosition: 'top',
                                                label: _('GYD'), // Localized label
                                                name: 'trmGyd', // Input name
                                                type: 'number', // Number input
                                            },
                                            {
                                                view: 'text', // Text input for VES
                                                labelPosition: 'top',
                                                label: _('VES'), // Localized label
                                                name: 'trmVes', // Input name
                                                type: 'number', // Number input
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                cols: [
                                    // Button row
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Localized label
                                        click: function () {
                                            // Cancel button click
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('editform').setValues(
                                                // Reset form values
                                                $$('editform').getCleanValues(),
                                            );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form', // Button type
                                        value: _('Guardar'), // Localized label
                                        click: function ($e) {
                                            // Save button click
                                            var values = $$('editform').getValues(); // Get form values
                                            if ($$('editform').validate()) {
                                                // Validate form
                                                values.Partner = id_partner; // Add partner ID to values
                                                webix
                                                    .ajax() // AJAX request to save data
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Setting/SaveCurrenciesTrm', // API URL for saving
                                                        values, // Data to send
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message(
                                                                    'Error! ', // Show error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                text = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (
                                                                    text.HasError // Check for errors in response
                                                                ) {
                                                                    webix.message(
                                                                        'Error: ' + text.AlertMessage, // Show error message
                                                                    );
                                                                } else {
                                                                    webix.message(
                                                                        'TRM editada satisfactoriamente', // Show success message
                                                                    );
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data
                                                                    );
                                                                }
                                                            },
                                                        },
                                                    );
                                                this.getTopParentView().hide(); // Hide the window
                                            } else {
                                                webix.message({
                                                    // Show validation error message
                                                    title: _('¡Error!'),
                                                    type: 'alert-error',
                                                    text: _(
                                                        'Completa los campos...', // Prompt to complete fields
                                                    ),
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                })
                .show(); // Show the edit window
            $$('editform').parse(item); // Populate the form with item data
        });
    }
}

// FILE DOCUMENTED
